// source: witbooking/backoffice/engineproviderbrandconfiguration/v1/engineproviderbrandconfiguration_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.displayName = 'proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    engineproviderbrandconfiguration: (f = msg.getEngineproviderbrandconfiguration()) && proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.deserializeBinaryFromReader);
      msg.setEngineproviderbrandconfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEngineproviderbrandconfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineProviderBrandConfiguration engineProviderBrandConfiguration = 1;
 * @return {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.prototype.getEngineproviderbrandconfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.prototype.setEngineproviderbrandconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.prototype.clearEngineproviderbrandconfiguration = function() {
  return this.setEngineproviderbrandconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationResponse.prototype.hasEngineproviderbrandconfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    engineproviderbrandconfiguration: (f = msg.getEngineproviderbrandconfiguration()) && proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.deserializeBinaryFromReader);
      msg.setEngineproviderbrandconfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEngineproviderbrandconfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineProviderBrandConfiguration engineProviderBrandConfiguration = 1;
 * @return {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.prototype.getEngineproviderbrandconfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.prototype.setEngineproviderbrandconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.prototype.clearEngineproviderbrandconfiguration = function() {
  return this.setEngineproviderbrandconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationRequest.prototype.hasEngineproviderbrandconfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.CreateGetEngineProviderBrandConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    engineproviderbrandconfiguration: (f = msg.getEngineproviderbrandconfiguration()) && proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.deserializeBinaryFromReader);
      msg.setEngineproviderbrandconfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEngineproviderbrandconfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineProviderBrandConfiguration engineProviderBrandConfiguration = 1;
 * @return {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.prototype.getEngineproviderbrandconfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.prototype.setEngineproviderbrandconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.prototype.clearEngineproviderbrandconfiguration = function() {
  return this.setEngineproviderbrandconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationRequest.prototype.hasEngineproviderbrandconfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.UpdateGetEngineProviderBrandConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.DeleteGetEngineProviderBrandConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    domain: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string domain = 1;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainRequest.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    engineproviderbrandconfiguration: (f = msg.getEngineproviderbrandconfiguration()) && proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.deserializeBinaryFromReader);
      msg.setEngineproviderbrandconfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEngineproviderbrandconfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineProviderBrandConfiguration engineProviderBrandConfiguration = 1;
 * @return {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.prototype.getEngineproviderbrandconfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.prototype.setEngineproviderbrandconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.prototype.clearEngineproviderbrandconfiguration = function() {
  return this.setEngineproviderbrandconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationByDomainResponse.prototype.hasEngineproviderbrandconfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    engineproviderbrandconfiguration: (f = msg.getEngineproviderbrandconfiguration()) && proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.deserializeBinaryFromReader);
      msg.setEngineproviderbrandconfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEngineproviderbrandconfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineProviderBrandConfiguration engineProviderBrandConfiguration = 1;
 * @return {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.prototype.getEngineproviderbrandconfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.prototype.setEngineproviderbrandconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.prototype.clearEngineproviderbrandconfiguration = function() {
  return this.setEngineproviderbrandconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.GetEngineProviderBrandConfigurationUsedByPropertyResponse.prototype.hasEngineproviderbrandconfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, ""),
    externalsitetype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteType} */ (reader.readEnum());
      msg.setExternalsitetype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExternalsitetype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ExternalSiteType externalSiteType = 2;
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteType}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.prototype.getExternalsitetype = function() {
  return /** @type {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteType} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.prototype.setExternalsitetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    multimedia: (f = msg.getMultimedia()) && witbooking_backoffice_common_common_pb.Multimedia.toObject(includeInstance, f),
    logotype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new witbooking_backoffice_common_common_pb.Multimedia;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Multimedia.deserializeBinaryFromReader);
      msg.setMultimedia(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoType} */ (reader.readEnum());
      msg.setLogotype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMultimedia();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      witbooking_backoffice_common_common_pb.Multimedia.serializeBinaryToWriter
    );
  }
  f = message.getLogotype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional witbooking.backoffice.common.Multimedia multimedia = 1;
 * @return {?proto.witbooking.backoffice.common.Multimedia}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.prototype.getMultimedia = function() {
  return /** @type{?proto.witbooking.backoffice.common.Multimedia} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Multimedia, 1));
};


/**
 * @param {?proto.witbooking.backoffice.common.Multimedia|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.prototype.setMultimedia = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.prototype.clearMultimedia = function() {
  return this.setMultimedia(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.prototype.hasMultimedia = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LogoType logoType = 2;
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoType}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.prototype.getLogotype = function() {
  return /** @type {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoType} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.prototype.setLogotype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailaddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    emailtype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailaddress(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailType} */ (reader.readEnum());
      msg.setEmailtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailaddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmailtype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string emailAddress = 1;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.prototype.getEmailaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.prototype.setEmailaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional EmailType emailType = 2;
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailType}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.prototype.getEmailtype = function() {
  return /** @type {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailType} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.prototype.setEmailtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.repeatedFields_ = [4,5,6,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    palette: (f = msg.getPalette()) && witbooking_backoffice_common_common_pb.Palette.toObject(includeInstance, f),
    logoconfigurationsList: jspb.Message.toObjectList(msg.getLogoconfigurationsList(),
    proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.toObject, includeInstance),
    emailconfigurationsList: jspb.Message.toObjectList(msg.getEmailconfigurationsList(),
    proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.toObject, includeInstance),
    externalsiteconfigurationsList: jspb.Message.toObjectList(msg.getExternalsiteconfigurationsList(),
    proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.toObject, includeInstance),
    company: (f = msg.getCompany()) && proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.toObject(includeInstance, f),
    relatedDomainsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    usedByList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new witbooking_backoffice_common_common_pb.Palette;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.Palette.deserializeBinaryFromReader);
      msg.setPalette(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.deserializeBinaryFromReader);
      msg.addLogoconfigurations(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.deserializeBinaryFromReader);
      msg.addEmailconfigurations(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.deserializeBinaryFromReader);
      msg.addExternalsiteconfigurations(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company;
      reader.readMessage(value,proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addRelatedDomains(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsedBy(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPalette();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_backoffice_common_common_pb.Palette.serializeBinaryToWriter
    );
  }
  f = message.getLogoconfigurationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getEmailconfigurationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getExternalsiteconfigurationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.serializeBinaryToWriter
    );
  }
  f = message.getRelatedDomainsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getUsedByList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional witbooking.backoffice.common.Palette palette = 3;
 * @return {?proto.witbooking.backoffice.common.Palette}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getPalette = function() {
  return /** @type{?proto.witbooking.backoffice.common.Palette} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_common_common_pb.Palette, 3));
};


/**
 * @param {?proto.witbooking.backoffice.common.Palette|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setPalette = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearPalette = function() {
  return this.setPalette(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.hasPalette = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated LogoConfiguration logoConfigurations = 4;
 * @return {!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration>}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getLogoconfigurationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration, 4));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration>} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setLogoconfigurationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.addLogoconfigurations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoConfiguration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearLogoconfigurationsList = function() {
  return this.setLogoconfigurationsList([]);
};


/**
 * repeated EmailConfiguration emailConfigurations = 5;
 * @return {!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration>}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getEmailconfigurationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration, 5));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration>} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setEmailconfigurationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.addEmailconfigurations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailConfiguration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearEmailconfigurationsList = function() {
  return this.setEmailconfigurationsList([]);
};


/**
 * repeated ExternalSiteConfiguration externalSiteConfigurations = 6;
 * @return {!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration>}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getExternalsiteconfigurationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration, 6));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration>} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setExternalsiteconfigurationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.addExternalsiteconfigurations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteConfiguration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearExternalsiteconfigurationsList = function() {
  return this.setExternalsiteconfigurationsList([]);
};


/**
 * optional Company company = 7;
 * @return {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getCompany = function() {
  return /** @type{?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company, 7));
};


/**
 * @param {?proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated string related_domains = 8;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getRelatedDomainsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setRelatedDomainsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.addRelatedDomains = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearRelatedDomainsList = function() {
  return this.setRelatedDomainsList([]);
};


/**
 * repeated string used_by = 9;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getUsedByList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setUsedByList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.addUsedBy = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearUsedByList = function() {
  return this.setUsedByList([]);
};


/**
 * optional google.protobuf.Timestamp created_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
*/
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EngineProviderBrandConfiguration.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company;
  return proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string phone = 2;
 * @return {string}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company} returns this
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.Company.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.LogoType = {
  INVALID_LOGO_TYPE: 0,
  LARGE: 1,
  LARGE_WHITE: 2,
  FAVICON: 3
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.ExternalSiteType = {
  INVALID_EXTERNAL_SITE_TYPE: 0,
  SUPPORT_CENTER: 1,
  KNOWLEDGE_DATABASE: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.engineproviderbrandconfiguration.v1.EmailType = {
  INVALID: 0,
  NO_REPLY: 1,
  CONTACT_EMAIL: 2
};

goog.object.extend(exports, proto.witbooking.backoffice.engineproviderbrandconfiguration.v1);
